// Установка сессии после входа/подтверждения почты.
import { get, post, setAccessToken } from '@/api/client';
import { connectSocket } from '@/api/socket';
import type { SessionResponse } from '@/api/types';
import { isLang, setLanguage } from '@/i18n';
import { platform, platformData } from '@/lib/platform';
import { useGame } from '@/store/game';

/** Билет входа через аккаунт (Google/VK/…), который надо привязать после входа по почте. */
export const OAUTH_LINK_KEY = 'sk_oauth_link';

export async function linkPlatformAccount(): Promise<void> {
  let ticket: string | null = null;
  try {
    ticket = sessionStorage.getItem(OAUTH_LINK_KEY);
    sessionStorage.removeItem(OAUTH_LINK_KEY);
  } catch {
    // нет хранилища
  }
  if (ticket) await post('/auth/platform/link', { platform: 'oauth', data: ticket }).catch(() => undefined);
  if (!platform) return;
  try {
    const data = await platformData();
    if (data) await post('/auth/platform/link', { platform, data });
  } catch {
    // уже привязан к другому игроку или платформа не дала данных — не мешаем игре
  }
}

export async function startSession(s: SessionResponse): Promise<void> {
  setAccessToken(s.accessToken);
  useGame.getState().setUser(s.user);
  if (isLang(s.user.locale)) setLanguage(s.user.locale);
  document.documentElement.dataset.theme = s.user.theme;
  connectSocket();
  // Вход по почте внутри платформы — привязываем аккаунт платформы (дальше вход без пароля)
  void linkPlatformAccount();
  try {
    useGame.getState().setFlags((await get<{ flags: string[] }>('/flags')).flags);
  } catch {
    // флаги необязательны
  }
}
